module.exports = "pegasus_template/assets/tech/holiday_2/101.png";